export default {
    "r-nomad.com": {
        banner: "r-nomad.gif",
        name: "恋愛遊牧民Ｒ+",
        url: "https://r-nomad.com/",
        official: true
    },
    "compslink.jp": {
        banner: "compass-link.png",
        name: "COMPASS LINK(コンパスリンク)",
        url: "https://compslink.jp/",
        official: true
    },
    "lony.jp": {
        banner: "lony.png",
        name: "創作サイト総合サーチ Lony",
        url: "https://lony.jp/",
        official: false
    },
    "www.dabun-doumei.com": {
        banner: "dabun-doumei.gif",
        name: "駄文同盟.com",
        url: "http://www.dabun-doumei.com/",
        official: false
    },
    "jhnet.sakura.ne.jp/piasunet": {
        banner: "piasunet.gif",
        name: "ぴあすねっとNAVI",
        url: "https://jhnet.sakura.ne.jp/piasunet/",
        official: false
    },
    "jhnet.sakura.ne.jp/tentatively": {
        banner: "tentatively.png",
        name: "幻想検索　tentatively",
        url: "https://jhnet.sakura.ne.jp/tentatively/",
        official: false
    },
    "bungeiweb.net": {
        banner: "bungeiweb.gif",
        name: "文芸Webサーチ",
        url: "https://bungeiweb.net/",
        official: false
    },
}